import { useQuery } from 'react-query'
import { postJSON } from 'common/services/api'
import {
  CHECK_ROTA_GENERATED_QUERY_KEY,
  ROTA_GENERATED_URL,
} from './queryConstants'
import dayjs from 'dayjs'
import { YEAR_FIRST_DATE_FORMAT } from '../utils.datetime'

type UseCheckGeneratedRotaProps = {
  selectedDate: Date
}

const useCheckGeneratedRota = ({
  selectedDate,
}: UseCheckGeneratedRotaProps) => {
  return useQuery(
    [CHECK_ROTA_GENERATED_QUERY_KEY, selectedDate],
    async () => {
        const result = await postJSON({
          url: ROTA_GENERATED_URL,
          method: 'POST',
          json: {
            startDate: dayjs(selectedDate)
              .startOf('isoWeek')
              .format(YEAR_FIRST_DATE_FORMAT),
            endDate: dayjs(selectedDate)
              .endOf('isoWeek')
              .format(YEAR_FIRST_DATE_FORMAT),
          },
          isRota: true,
        })
        return result
    },
    { retry: false },
  )
}

export default useCheckGeneratedRota
